/**
 * 采购端竞价api
 * author：胡枭
 */

import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
// const baseUrl = 'http://z.a.cn:8083'

// 获取竞价单列表（分页）
export function getCompeteListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/competition-orders',
    method: 'get',
    params
  })
}

// 新增，发布竞价单信息
export function addPublishCompeteMesApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/competition-orders/publish',
    method: 'post',
    data
  })
}

// 新增，保存竞价单信息
export function addStoreCompeteMesApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/competition-orders',
    method: 'post',
    data
  })
}

// 编辑，发布竞价单
export function editPublishCompeteMesApi(data, ids) {
  const { orderId } = ids
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}/publish`,
    method: 'put',
    data
  })
}

// 编辑，保存竞价单
export function editStoreCompeteMesApi(data, ids) {
  const { orderId } = ids
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}`,
    method: 'put',
    data
  })
}

// 删除竞价单 （只有未发布的可以删除）
export function deleteCompeteApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}`,
    method: 'delete'
  })
}

// 变更竞价单
export function changeCompeteMesApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/publish-change`,
    method: 'post',
    data
  })
}

// 获取竞价单详情
export function getCompeteMesApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}/detail`,
    method: 'get'
  })
}

// 嘉宾进入竞价大厅，获取竞价单信息
export function getCompeteMesForGuestApi(orderId) {
  return request({
    url: baseUrl + `/workbench/competition-hall/${orderId}/guest-door`,
    method: 'get'
  })
}

// 竞价单报名分页列表
export function getCompeteSignUpListApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/trades/page`,
    method: 'get',
    params
  })
}

// 查询报名供应商报名情况列表
export function getCompeteSignCntApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}/supplier-applies/total`,
    method: 'get'
  })
}

// 竞价单报名详情
export function getCompeteSignUpDetailApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/trades/${tradeId}/sign-up`,
    method: 'get'
  })
}

// 报名审核
export function auditCompeteSignUpApi(data, orderId, tradeId, approvalId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/trades/${tradeId}/sign-up/approval?approvalId=${approvalId}`,
    method: 'put',
    data
  })
}

// 查询交易下审核单列表(报名)
export function getAuditHistoryListApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/trades/${tradeId}/sign-approvals`,
    method: 'get'
  })
}

// 竞价单邀请分页列表
export function getCompeteInviteListApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/invitations/page`,
    method: 'get',
    params
  })
}

// 竞价单邀请详情
export function getCompeteInviteDetailApi(inviteId, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/invitations/${inviteId}`,
    method: 'get'
  })
}

// 保存成交供应商公告
export function storeCompetePublicNoticeApi(data, orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}/winner`,
    method: 'post',
    data
  })
}

// 发布成交供应商公告
export function publishCompetePublicNoticeApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/winner/publish`,
    method: 'post',
    data
  })
}

// 查询竞价中，最优价格供应商列表
export function getCompeteWinnerListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/current-offer`,
    method: 'get'
  })
}

// 查询竞价成交供应商详情
export function competePublicNoticeDetailApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/competition-orders/${orderId}/winner`,
    method: 'get'
  })
}

// 获取变更公告信息
export function competeChangeAnnListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/change-notices`,
    method: 'get'
  })
}

// 异常---追加邀请供应商
export function addCompeteInviteSupplierApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/abnormal/supplement-invites`,
    method: 'post',
    data
  })
}

// 异常---流标表单信息查询
export function getCompeteAbnormalMesApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/abnormal/fail-close`,
    method: 'get'
  })
}

// 异常---保存流标信息
export function storeCompeteAbnormalMesApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/abnormal/fail-close`,
    method: 'post',
    data
  })
}

// 异常---关闭竞价
export function closeCompeteAbnormalApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/abnormal/fail-close/publish`,
    method: 'post',
    data
  })
}

// 异常---重新竞价
export function reCompeteAbnormalApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/abnormal/fail-close/publish-create`,
    method: 'post',
    data
  })
}

// 查询供应商的证件要求列表
export function getSupplierRequireListApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/trades/${tradeId}/cert-require`,
    method: 'get'
  })
}

// 批量导入竞价品目
export function importCompeteMaterialApi(data) {
  return request(
    {
      url: baseUrl + `/workbench/template/competition-materiel/import`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 预览竞价文件
export function previewPurchaseCompeteFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/preview-supplement-file`,
    method: 'get',
    params
  })
}

// 下载竞价文件
export function downloadPurchaseCompeteFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/download-supplement-file`,
    method: 'get',
    params
  })
}

// 发布竞价澄清说明
export function publishClarificationFileApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/file-supplement`,
    method: 'post',
    data
  })
}

// 获取文件澄清列表
export function getSupplementListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/file-supplements`,
    method: 'get'
  })
}

// 获取已发布的公告列表
export function getCompetePublishNoticeApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/release-notices`,
    method: 'get'
  })
}

// 查询最近的变更数据
export function getCompeteNewestChangeInfoApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/competition-orders/${orderId}/notice-changes/last/detail`,
    method: 'get'
  })
}
